__turbopack_context__.v({
  "className": "geist_7d0036ad-module__X4HdpG__className",
  "variable": "geist_7d0036ad-module__X4HdpG__variable",
});
